import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "@shared/models/redux";
import { AccountFundAccessResponse } from "@myProfile/models";

export const fetchAccountFundAccessThunk = createAsyncThunk<AccountFundAccessResponse, number, ThunkApiConfig>(
  "myProfile/fetchAccountFundAccess",
  async (entitledUserId, { extra, rejectWithValue }) => {
    try {
      const url = `/entitlements/v1/user/FundsServicesAndNotificationsInfo`;

      // Pass entitledUserId only once via queryParams and disable global param injection
      const response = await extra<AccountFundAccessResponse>(
        url,
        {
          method: "GET",
          queryParams: { entitledUserId },
        },
        { includeUserId: false, includeAccountGroupId: false }
      );

      return response.data;
    } catch (error) {
      console.error("[Account/Fund Access API] Error fetching data:", error);

      return rejectWithValue("Failed to fetch account and fund access data");
    }
  }
);
